import { LoadingButton } from "@mui/lab";
import { alpha } from "@mui/material";
import { CSSProperties, useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useGetConnectExitCallback from "src/pages/Link/Products/ConnectAccount/ConnectStep/hook/useGetConnectExitCallback";

import ThemeContext from "../../context";

// ----------------------------------------------------------------------

export const CustomReturnBtn = () => {
	const { customConnectProps } = useContext(ThemeContext);

	const { translate } = useLocales();
	const { onExit } = useGetConnectExitCallback();

	const buttonStyle: CSSProperties = {
		borderRadius: customConnectProps?.theme?.button?.shape,
		backgroundColor: customConnectProps?.theme?.colors?.buttonBackground,
		color: customConnectProps?.theme?.colors?.buttonText,
		fontWeight: customConnectProps?.theme?.button?.textWeight === "BOLD" ? 700 : 500,
		fontSize: 14,
		width: customConnectProps?.theme?.button?.width,
		boxShadow: `0 8px 16px 0 ${alpha(
			customConnectProps?.theme?.colors?.buttonBackground ?? "#000",
			0.24
		)}`
	};

	return (
		<LoadingButton
			size='large'
			style={buttonStyle}
			onClick={() => onExit("ERROR")}
			sx={{ mt: 5, width: "100%", alignSelf: "center" }}
			variant='outlined'
		>
			{translate(`Salir`)}
		</LoadingButton>
	);
};

export default CustomReturnBtn;
